import React, { Component } from 'react';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Ionicon from 'react-ionicons';
import styles from './styles';

import swal from 'sweetalert2';

import api from '../../api';

// Custom Components
import LoginBlock from '../../components/LoginBlock';

class Privacy extends Component {
  state = {
    content: ''
  };

  componentDidMount() {
    this._fetchPolicy();
  }

  _fetchPolicy = () => {
    api
      .getPrivacyContent()
      .then(content => {
        this.setState({ content });
      })
      .catch(err => {
        console.log(err);
      });
  };

  _handleGoBack = () => {
    this.props.changePage('/more');
  };

  render() {
    const { loggedIn, classes } = this.props;

    if (!loggedIn) {
      return <LoginBlock />;
    }

    const { content } = this.state;

    return (
      <Grid container className={classes.root} spacing={0}>
        <span className={classes.backButton} onClick={this._handleGoBack}>
          <Ionicon
            icon="md-arrow-back"
            style={{
              marginRight: 5,
              marginBottom: 2,
              color: '#122B4F'
            }}
          />
          Back
        </span>

        <Grid item xs={12}>
          <div
            className={classes.content}
            dangerouslySetInnerHTML={{ __html: content }}
          />
        </Grid>
      </Grid>
    );
  }
}

Privacy = withStyles(styles)(Privacy);

const mapStateToProps = state => ({
  loggedIn: state.user.loggedIn
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changePage: url => push(url)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Privacy);



// WEBPACK FOOTER //
// ./src/containers/privacy/index.js